import { Flags } from 'flagsmith-nodejs';
import IFlagsmith from 'flagsmith';
import React from 'react';

// sort flags alphabetically to match flag-smith order
export const DefaultFlagsContext = {
  EnableAppSetupImprovements: false,
  EnableEmailNotificationsDigest: false,
  EnableFilesNotificationCenter: false,
  EnableImprovedOnboarding: false,
  GoogleLoginForInternalUser: false,
  GoogleLoginForClients: false,
};

export type FlagContextType = Record<keyof typeof DefaultFlagsContext, boolean>;

export const getServerFlagsContextValue = (flags: Flags) => ({
  EnableAppSetupImprovements: flags.isFeatureEnabled(
    'enable_app_setup_improvements',
  ),
  EnableFilesNotificationCenter: flags.isFeatureEnabled(
    'enable_files_notification_center',
  ),
  EnableImprovedOnboarding: flags.isFeatureEnabled(
    'enable_improved_onboarding',
  ),
  GoogleLoginForInternalUser: flags.isFeatureEnabled(
    'google_login_for_internal_user',
  ),
  GoogleLoginForClients: flags.isFeatureEnabled('google_login_for_clients'),
});

export const getClientFlagsContextValue = (flags: typeof IFlagsmith) => ({
  EnableAppSetupImprovements: flags.hasFeature('enable_app_setup_improvements'),
  EnableFilesNotificationCenter: flags.hasFeature(
    'enable_files_notification_center',
  ),
  EnableImprovedOnboarding: flags.hasFeature('enable_improved_onboarding'),
  GoogleLoginForInternalUser: flags.hasFeature(
    'google_login_for_internal_user',
  ),
  GoogleLoginForClients: flags.hasFeature('google_login_for_clients'),
});

export const FlagsContext = React.createContext(DefaultFlagsContext);
